export const InviteMailAPI = async (email, assignerName) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-invite-mail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                assignerName: assignerName
            })
        });

        if (!response.ok) {
            console.error(`Failed to send invite mail, status: ${response.status}`);
            return null;
        }

        return await response.json();

    } catch (error) {
        console.error("Error sending invite mail:", error);
        return null;
    }
};
